<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a drop down to select campaign based on school
    * returns both the school and campaign selected
    *
    * @since 20200911
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="row">
        <div class="form-group col-6">
            <school-drop
                :value="schoolData" v-on:input="update_school($event)"
                :name="sch_input" :schools="schools"
                :school_name="school_name"
                :loadasyncroute="loadasyncroute"
                :user_website_id="user_website_id"
                :refresh_data="refresh_data"
            ></school-drop>
        </div>      
        <div class="form-group col-6"><label>Campaign</label>
            <select class="form-control form-control" :name="camp_input" :value="campaignData" v-on:input="update_camp($event)" >
                <option value="0">Please select a Campaign</option>
                <option v-for="camp in currentCampaigns" :key="camp.id" :value="camp.id">{{camp.name}} - <span v-if="camp.end_date === null">Any Date</span><span v-else>{{formatdate(camp.start_date)}}</span></option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            //the name of the input
            start: {
                type: String,
                default: ''
            },
            //the schools
            schools: {
                type: Array
            },
            //the campaigns
            campaigns: {
                type: Array
            },
            //the value
            value: {
                type: String
            },
            //the name of schools
            school_name: {
                default: Object
            },
            //the width
            width: {
                default: ''
            },
            loadasyncroute: {
                type: String,
                default: ''
            },
            user_website_id: {
                type: String,
                default: '0_0'
            },
            refresh_data: {
                type: Boolean,
                default: false
            }
        },
        mounted(){
        },
        data() {
            return {
                schoolData: JSON.parse(this.value.replace(/\|/g, ',')).school !== undefined ? JSON.parse(this.value.replace(/\|/g, ',')).school : 0,
                campaignData: JSON.parse(this.value.replace(/\|/g, ',')).campaign !== undefined ? JSON.parse(this.value.replace(/\|/g, ',')).campaign : 0,
                //the name of the input
                start_data: this.start
            };
        },
        computed: {
            /**
             * returns current list of jobs
             * 
             * @return Array the list
             */
            currentCampaigns: function () {
                var camps = [];
                var schoolList = [];
                if (typeof this.schoolData === 'string' || this.schoolData instanceof String){
                    schoolList = this.schoolData.split(',');
                } else {
                    schoolList = [parseInt(this.schoolData)];
                }
                for(var i=0; i<this.campaigns.length; i++){
                    if(this.campaigns[i].schools.length <= 0){
                        camps.push(this.campaigns[i]);
                    } else {
                        for(var j=0; j<this.campaigns[i].schools.length; j++){
                            for(var k=0; k<schoolList.length; k++){
                                if(this.campaigns[i].schools[j].id == schoolList[k]){
                                    camps.push(this.campaigns[i]);
                                }
                            }
                        }
                    }
                }
                return camps;
            },
            /**
             * returns the name of the industry input
             * 
             * @return String the name
             */
            sch_input: function () {return this.start_data + 'school'},
            /**
             * returns the name of the job input
             * 
             * @return String the name
             */
            camp_input: function () {return this.start_data + 'campaign'},
        },
        methods: {
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_school: function (value) {
                //if(this.industry_data != 0){
                    this.campaignData = 0;
                //}
                if(value.target !== undefined){
                    this.schoolData = value.target.value;
                } else {
                    this.schoolData = value;
                }
                //because it is used with the filters, replace commas with | so that it doesn't get confused when exploding
                this.$emit('input', JSON.stringify({school: this.schoolData,campaign:this.campaignData}).replace(/,/g, '|'));
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_camp: function (value) {
                this.campaignData = value.target.value;
                //because it is used with the filters, replace commas with | so that it doesn't get confused when exploding
                this.$emit('input', JSON.stringify({school: this.schoolData,campaign:this.campaignData}).replace(/,/g, '|'));
            },
            /**
             * formats a date for displaying
             * 
             * @param Date date the date to display
             * @returns String the formatted date
             */
            formatdate: function (dt){
                if(dt == null || dt == undefined){
                    return '';
                } else {
                    var date = new Date(dt);
                    var day = date.getDate() + '';
                    if(day.length == 1){
                        var day = '0' + day;
                    }
                    var month = (date.getMonth()+1) + '';
                    if(month.length == 1){
                        var month = '0' + month;
                    }
                    return day + '/' + month + '/' + date.getFullYear();
                }
            },
        },
    }
</script>
